import { asset } from '@/lib/assets'
import { SITE_URL } from '@/lib/siteUrl'
import {
  CAMPAIGN_ICON_FEEDBACK,
  CAMPAIGN_ICON_FORUM,
  CAMPAIGN_ICON_MENU_BOOK,
  CAMPAIGN_PAGE_BACKGROUND,
} from '@/components/campaign/sharedAssets'
import type { InterviewPracticeCampaignConfig } from '@/components/campaign/types'

/** Figma: Landing-page-meritlens → Final (2154:269) → MLOps (Desktop 12 / iPhone 14 & 15 Pro - 6). */
const IMG_HERO = asset('/assets/images/data-analytics-engineering/hero-mlops-pipeline.png')
const IMG_OFFER_CARD = asset('/assets/images/data-analytics-engineering/mlops-offer-card.png')

const OG_IMAGE = `${SITE_URL}/images/backgroundImages.jpg`

export const mlopsForwardDeployedCampaignConfig: InterviewPracticeCampaignConfig = {
  path: '/mlops-forward-deployed-engineering',
  analyticsSource: 'mlops_forward_deployed_engineering',
  analytics: {
    pageViewed: 'mlops_page_viewed',
    ctaClicked: 'mlops_cta_clicked',
    checkoutStarted: 'mlops_checkout_started',
  },
  idPrefix: 'mlops',

  seo: {
    title: 'MLOps & Forward-Deployed Engineering Interview Practice',
    description:
      'Practice serving costs, model monitoring, and debugging distributed systems in production. Sharpen your technical narrative for MLOps and forward-deployed engineering interviews.',
    openGraphTitle: 'MLOps & Forward-Deployed Engineering Interview Practice | meritlens',
    openGraphDescription:
      'From debugging systems to cracking interviews. Show the panel you think like a senior engineer.',
    twitterDescription:
      'Realistic MLOps and FDE interview practice with structured feedback tailored to your resume.',
    heroImageForSharing: OG_IMAGE,
    heroImageAlt: 'MLOps and forward-deployed engineering interview practice with meritlens',
  },

  hero: {
    roleBadge: 'MLOps & Forward-Deployed Engineering',
    titleLine: 'From Debugging Systems to',
    titleAccent: 'Cracking Interviews.',
    subtitle:
      'Show the panel you think like a senior engineer, not just a model builder.',
    heroImageSrc: IMG_HERO,
    heroImageAlt: 'MLOps and forward-deployed engineering interview practice with meritlens',
    caption:
      'Practice tackling complex questions on serving costs, model monitoring, and debugging distributed systems in production. With meritlens, sharpen your technical narrative and demonstrate the maturity hiring teams expect.',
  },

  pageBackgroundImage: CAMPAIGN_PAGE_BACKGROUND,

  offer: {
    cardTitle: 'Land Your Next MLOps Offer',
    offerPreviewImage: IMG_OFFER_CARD,
    microcopy: 'Prepare smarter for your next MLOps or FDE interview.',
    bullets: [
      'Practice real interview questions tailored to your resume',
      'Get instant, detailed feedback to fix mistakes before the real panel',
    ],
  },

  why: {
    intro:
      'Go beyond theory. Practice explaining technical decisions, solving problems, and connecting concepts to real engineering scenarios.',
    features: [
      {
        icon: CAMPAIGN_ICON_FORUM,
        titleDesktop: 'Realistic Technical Interview Practice',
        titleMobile: 'Realistic technical interview practice',
        description:
          'Practise interview-style questions across machine learning operations and applied engineering.',
      },
      {
        icon: CAMPAIGN_ICON_MENU_BOOK,
        titleDesktop: 'Put Your Problem-Solving to the Test',
        titleMobile: 'Put your problem-solving to the test',
        description:
          'Work through questions involving model deployment, API integrations, debugging, and system design.',
      },
      {
        icon: CAMPAIGN_ICON_FEEDBACK,
        titleDesktop: 'Get Structured Feedback',
        titleMobile: 'Get structured feedback',
        description:
          'Identify your strengths and areas to improve before your next technical interview.',
      },
    ],
  },
}
